<template>
  <div class="page-content">
    <div class="row">
      <div class="col-md-12" v-if="steps_list.length > 0">
        <div class="card ml-2 mb-3">
          <div class="card-body d-flex justify-content-between">
            <div class="d-flex">
              <button class="btn btn-outline-primary" @click="addCard">
                <font-awesome icon="plus"/> Add Leads
              </button>
              <div class="row ml-4">
                <div class="col-4 col-sm-4">
                  <el-select v-model="search.filter_type" placeholder="Filter type" style="width:100%">
                    <el-option label="Lead" value="lead"></el-option>
                    <el-option label="Contact" value="contact"></el-option>
                    <el-option label="Assignee" value="user"></el-option>
                  </el-select>
                </div>
                <div class="col-8 col-sm-8">
                  <form class="search-form" @submit.prevent="loadData()">
                    <div class="input-group border rounded-sm">
                      <div class="input-group-prepend">
                        <div class="input-group-text border-0 rounded-sm">
                          <FeatherIcon type="search" class="icon-md cursor-pointer" />
                        </div>
                      </div>
                      <input v-model="search.search" type="text" class="form-control  border-0 rounded-sm" id="searchForm" placeholder="Search here...">
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <h4 class="float-right" style="font-size: 1.3rem;">Rp. {{ total_amount?.toLocaleString() }}</h4>
          </div>
        </div>
        <div class="d-flex justify-content-around table-responsive">
          <el-card class="box-card mx-2 overflow-auto" style="min-width: 30%; max-height: 500px;"
          v-for="(v,i) in listSteps()" :key="i" v-loading="loading.leads[v.key]">
            <div slot="header" class="clearfix" @drop="onDrop($event, v.key)" @dragover.prevent @dragenter.prevent>
              <div class="d-flex justify-content-between">
                <span><b>{{ v.label }}</b> ({{ v.count || 0 }})</span>
              </div>
              <p>Rp. {{ v.amount.toLocaleString() }}</p>
            </div>
            <div @drop="onDrop($event, v.key)" @dragover.prevent @dragenter.prevent>
              <div class="card card-list border-primary p-1 mt-2 cursor-pointer" v-for="(dt, idt) in v.data" :key="dt.id"
              draggable @dragstart="startDrag($event, v.key, idt)">
                <div class="card-list-body p-2">
                  <div class="">
                    <div class="d-flex justify-content-between">
                      <div class="d-flex align-items-top">
                        <!-- <div class="d-flex mr-2 mt-1">
                          <FeatherIcon style="margin-left: -5px" type="more-vertical" class="link-icon feather-16"/>
                          <FeatherIcon style="margin-left: -10px" type="more-vertical" class="link-icon feather-16"/>
                        </div> -->
                        <el-tooltip class="item" effect="dark" :content="`${dt.user?.name}${dt.participant}`" placement="top">
                          <div class="mt-1 mr-1" :data-initials-contact="initials(dt.user?.name)"/>
                        </el-tooltip>
                        <!-- <el-tooltip class="item" v-for="user in dt.participant" effect="dark" :content="`${user}`" placement="top">
                          <div class="mt-1 ml-n4" :data-initials-contact="initials(user)"/>
                        </el-tooltip> -->
                        <div>
                          <p><b>{{ dt.name }}</b></p>
                          <p>{{ isChatPrivacy(dt.contact_name) }} ({{ isChatPrivacy(dt.contact.phone_number) }})</p>
                          <p>{{ dt.amount ? `Rp. ${dt.amount_str}` : '-' }}</p>
                        </div>
                      </div>
                      <div class="align-items-top" v-if="(i+1) == steps_list.length">
                        <el-dropdown trigger="click" @command="completeLeads($event, dt)">
                          <span class="el-dropdown-link">
                            <i class="el-icon-arrow-down el-icon--right"></i>
                          </span>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item class="text-primary" command="won"><b>Won</b></el-dropdown-item>
                            <el-dropdown-item class="text-danger" command="lost"><b>Lost</b></el-dropdown-item>
                            <el-dropdown-item class="text-danger" command="close"><b>Close</b></el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                      </div>
                    </div>
                    <div class="d-flex justify-content-between align-items-center mt-2">
                      <div class="d-flex">
                        <el-tooltip class="item" effect="dark" content="Detail" placement="top">
                          <button class="btn btn-outline-primary mr-1 btn-xs mt-2 p-1" @click="detailCard(dt)">
                            <font-awesome icon="eye"/>
                          </button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="Edit" placement="top">
                          <button class="btn btn-outline-warning mr-1 btn-xs mt-2 p-1" @click="editCard(dt)">
                            <font-awesome icon="edit"/>
                          </button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="Delete" placement="top">
                          <button class="btn btn-outline-danger btn-xs mt-2 p-1" @click="deleteLeads(dt)">
                            <font-awesome icon="trash"/>
                          </button>
                        </el-tooltip>
                      </div>
                      <div class="d-flex align-items-center mt-2">
                        <span class="mr-2" style="font-size: 0.75rem;">{{ dt.due_date_str }}</span>
                        <b-badge :variant="dt.color_date" class="p-1">{{ dt.label_date }}</b-badge>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <el-empty v-if="v.data.length == 0" description="No data"></el-empty>
              <div>
                <el-link @click="loadListStep(v)" type="info" class="my-3 float-right" v-if="v.count_exist < v.count">Load More...</el-link>
              </div>
            </div>
          </el-card>
        </div>
      </div>
      <div class="col-md-12" v-else>
        <el-empty description="You have no step status for your leads. Let's add first!">
          <router-link class="btn btn-primary" to="/leads/settings">Let's go!</router-link>
        </el-empty>
      </div>
    </div>
    <!-- <b-modal v-model="modal.add" title="Add New Leads" hide-footer> -->
    <template v-if="current_step === 1">
      <el-dialog
        title="Additional Form"
        :visible.sync="modal.add"
        width="50%"
        :before-close="closeModal"
        top="10vh"
      >
        <el-form :model="form_fields_qs_answ" @reset="closeModal" class="p-1 full-width" ref="dynamicFormValidation">
          <el-form-item v-for="(dy_form, idx_dynamic_form) in paginatedDynamicForm" :key="idx_dynamic_form" :rules="[{ validator: validateRequiredField(dy_form), trigger: 'blur' }]" :prop="dy_form.key">
            <p class="mb-2">{{ `${dy_form.label} :` }}</p>
            <el-input :name="dy_form.key" type="name" v-if="dy_form.type === 'text'" :required="dy_form.required" v-model="dy_form.value" />
            <el-input :name="dy_form.key" type="number" v-else-if="dy_form.type === 'number'" :required="dy_form.required" v-model="dy_form.value" />
            <el-input :name="dy_form.key" type="email" v-else-if="dy_form.type === 'email'" :required="dy_form.required" v-model="dy_form.value" />
            <el-date-picker style="width: 100%" :name="dy_form.key" type="date" v-else-if="dy_form.type === 'date'" :required="dy_form.required" v-model="dy_form.value" placeholder="Pick a date"></el-date-picker>
            <el-input :name="dy_form.key" type="textarea" v-else-if="dy_form.type === 'textarea'" v-model="dy_form.value" />
            <b-form-file
              v-else-if="dy_form.type === 'upload'"
              accept=".jpeg, .jpg, .png, .mp4, .doc, .docx, .xlsx, .xls, .pdf"
              placeholder="Choose a file"
              v-model="dy_form.value"
            ></b-form-file>
            <el-checkbox-group v-else-if="dy_form.type === 'select' && dy_form.subtype === 'multiple'" v-model="dy_form.value">
              <el-checkbox v-for="(list, idx_list) in dy_form.list" :key="idx_list" :label="list.label"></el-checkbox>
            </el-checkbox-group>
            <el-radio-group v-else-if="dy_form.type === 'select' && dy_form.subtype === 'single'" v-model="dy_form.value">
              <el-radio v-for="(list, idx_list) in dy_form.list" :key="idx_list" :label="list.label"></el-radio>
            </el-radio-group>
            <el-select style="width: 100%" v-else-if="dy_form.type === 'select' && dy_form.subtype === 'option'" :placeholder="'Choose ' + dy_form.label" v-model="dy_form.value">
              <el-option
                v-for="(list, idx_list) in dy_form.list"
                :key="idx_list"
                :label="list.label"
                :value="list.label">
              </el-option>
            </el-select>
          </el-form-item>
          <div class="d-flex justify-content-end mt-1">
            <el-button
              v-if="current_step > 0"
              size="small"
              type="primary"
              @click="backToStep"
              :loading="loading.step"
            >
              Back
            </el-button>
            <el-button
              v-if="current_step === 1 && dynamic_form.page < totalPages"
              size="small"
              type="primary"
              @click="validateLeadField(nextToStep)"
              :loading="loading.step"
            >
              Next
            </el-button>
            <el-button
              v-if="current_step === 1 && dynamic_form.page >= totalPages"
              size="small"
              type="primary"
              @click="validateCreateLeadField"
              :loading="loading.update_leads"
            >
              Submit
            </el-button>
          </div>
        </el-form>
      </el-dialog>
    </template>
    <template v-else>
      <el-dialog
        title="Add New Leads"
        :visible.sync="modal.add"
        :before-close="closeModal"
        width="50%">
        <el-form label-width="140px" @reset="closeModal" class="full-width mb-5">
          <el-form-item label="Lead name">
            <el-input v-model="form.name" placeholder="Please enter project name"></el-input>
          </el-form-item>
          <el-form-item label="Assign to">
            <el-select v-model="form.sales_id" filterable remote reserve-keyword :remote-method="searchUser"
            placeholder="Please enter a keyword" :loading="loading.get_users" style="width: 100%">
              <el-option
                v-for="item in filter_users"
                :key="item.id"
                :label="item.text"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Source">
            <el-select v-model="form.source"
            placeholder="Please enter a keyword" :loading="loading.get_users" style="width: 100%">
              <el-option
                v-for="(item, idx_filter_source) in filter_source"
                :key="idx_filter_source"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="form.source === 'Conversation'" label="Conversation">
            <el-select v-model="form.conversation_id" @change="onChangeSourceTypeId" filterable remote reserve-keyword :remote-method="searchConversations"
            clearable placeholder="Please enter ticket number" :loading="loading.get_conversations" style="width: 100%">
              <el-option
                v-for="item in filter_conversations"
                :key="item.conversation_id"
                :label="item.label"
                :value="item.conversation_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-else-if="form.source === 'Call'" label="Call">
            <el-select v-model="form.call_id" @change="onChangeSourceTypeId" filterable remote reserve-keyword :remote-method="searchCall"
            clearable placeholder="Please enter phone number" :loading="loading.get_call" style="width: 100%">
              <el-option
                v-for="item in filter_calls"
                :key="item.call_id"
                :label="item.label"
                :value="item.call_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-else label="Contact">
            <el-select v-model="form.contact_id"  filterable remote reserve-keyword ref="contact_type" :remote-method="searchContact"
            clearable placeholder="Please enter phone number" :loading="loading.get_contacts" style="width: 100%">
              <el-option
                v-for="item in filter_contacts"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Projection amount">
            <el-input v-model="form.amount" placeholder="Please enter project amount (optional)"
            :formatter="(value) => `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
            :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"></el-input>
          </el-form-item>
          <el-form-item label="Due Date">
            <el-date-picker
              v-model="form.due_date"
              type="date"
              width="100%"
              placeholder="Pick date (optional)"
              style="width: 100%"
            >
          </el-date-picker>
          </el-form-item>
          <el-form-item class="float-right">
            <el-button v-if="form_fields_qs_answ.length > 0" size="small" type="primary" @click="nextToStep" :loading="loading.step">Next</el-button>
            <el-button v-else size="small" type="primary" @click="createLeads" :loading="loading.update_leads">Submit</el-button>
            <el-button size="small" @click="closeModal">Cancel</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </template>
    <!-- </b-modal> -->
    <template v-if="current_step === 1">
      <el-dialog
        title="Additional Form"
        :visible.sync="modal.edit"
        :before-close="closeModal"
        width="50%"
      >
        <el-form :model="form_fields_qs_answ" @reset="closeModal" class="full-width p-1" ref="dynamicFormValidation">
          <el-form-item style="white-space: normal;" v-for="(dy_form, idx_dynamic_form) in paginatedDynamicForm" :key="idx_dynamic_form" :rules="[
            { validator: validateRequiredField(dy_form), trigger: 'blur' }
          ]" :prop="dy_form.key">
            <p class="mb-2">{{ `${dy_form.label} :` }}</p>
            <el-input :name="dy_form.key" type="name" v-if="dy_form.type === 'text'" v-model="dy_form.value" :required="dy_form.required" />
            <el-input :name="dy_form.key" type="number" v-else-if="dy_form.type === 'number'" :required="dy_form.required" v-model="dy_form.value" />
            <el-input :name="dy_form.key" type="email" v-else-if="dy_form.type === 'email'" :required="dy_form.required" v-model="dy_form.value" />
            <el-date-picker style="width: 100%" :name="dy_form.key" type="date" v-else-if="dy_form.type === 'date'" :required="dy_form.required" v-model="dy_form.value" placeholder="Pick a date"></el-date-picker>
            <el-input :name="dy_form.key" type="textarea" v-else-if="dy_form.type === 'textarea'" v-model="dy_form.value" :required="dy_form.required" />
            <b-form-file
              v-else-if="dy_form.type === 'upload'"
              accept=".jpeg, .jpg, .png, .mp4, .doc, .docx, .xlsx, .xls, .pdf"
              placeholder="Choose a file"
              :required="dy_form.required"
              v-model="dy_form.value"
            ></b-form-file>
            <div v-if="dy_form.type === 'upload' && dy_form.value && dy_form.value.secure_url" class="mt-2">
              <p>Uploaded file: {{ dy_form.value.secure_url }}</p>
            </div>
            <el-checkbox-group v-else-if="dy_form.type === 'select' && dy_form.subtype === 'multiple'" v-model="dy_form.value" :required="dy_form.required">
              <el-checkbox v-for="(list, idx_list) in dy_form.list" :key="idx_list" :label="list.label"></el-checkbox>
            </el-checkbox-group>
            <el-radio-group v-else-if="dy_form.type === 'select' && dy_form.subtype === 'single'" v-model="dy_form.value" :required="dy_form.required">
              <el-radio v-for="(list, idx_list) in dy_form.list" :key="idx_list" :label="list.label"></el-radio>
            </el-radio-group>
            <el-select style="width: 100%" v-else-if="dy_form.type === 'select' && dy_form.subtype === 'option'" :placeholder="'Choose ' + dy_form.label" v-model="dy_form.value" :required="dy_form.required">
              <el-option
                v-for="(list, idx_list) in dy_form.list"
                :key="idx_list"
                :label="list.label"
                :value="list.label">
              </el-option>
            </el-select>
          </el-form-item>
          <div class="d-flex justify-content-end mt-1">
            <el-button
              v-if="current_step > 0"
              size="small"
              type="primary"
              @click="backToStep"
              :loading="loading.step"
            >
              Back
            </el-button>
            <el-button
              v-if="current_step === 1 && dynamic_form.page < totalPages"
              size="small"
              type="primary"
              @click="validateLeadField(nextToStep)"
              :loading="loading.step"
            >
              Next
            </el-button>
            <el-button
              v-if="current_step === 1 && dynamic_form.page >= totalPages"
              size="small"
              type="primary"
              @click="validateUpdateLeadField"
              :loading="loading.update_leads"
            >
              Submit
            </el-button>
          </div>
        </el-form>
      </el-dialog>
    </template>
    <template v-else>
      <el-dialog
      title="Update Leads"
      :visible.sync="modal.edit"
      :before-close="closeModal"
      width="50%">
      <el-form @submit.prevent="updateLeads" label-width="100px" @reset="closeModal" class="full-width mb-5">
        <el-form-item label="Name">
          <el-input v-model="form.name" placeholder="Please enter project name"></el-input>
        </el-form-item>
        <el-form-item label="Assign to">
          <el-select v-model="form.sales_id" filterable remote reserve-keyword :remote-method="searchUser"
          placeholder="Please enter a keyword" :loading="loading.get_users" style="width: 100%">
            <el-option
              v-for="item in filter_users"
              :key="item.id"
              :label="item.text"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Source">
          <el-select disabled v-model="form.source" filterable remote reserve-keyword :remote-method="searchUser"
          placeholder="Please enter a keyword" :loading="loading.get_users" style="width: 100%">
            <el-option
              v-for="(item, idx_filter_source) in filter_source"
              :key="idx_filter_source"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Contact">
          <el-select disabled v-model="form.contact_id" filterable remote reserve-keyword :remote-method="searchContact"
          placeholder="Please enter phone number" :loading="loading.get_contacts" style="width: 100%">
            <el-option
              v-for="item in filter_contacts"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Amount">
          <el-input v-model="form.amount" placeholder="Please enter project amount"
          :formatter="(value) => `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
          :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"></el-input>
        </el-form-item>
        <el-form-item label="Due Date">
          <el-date-picker
            v-model="form.due_date"
            type="date"
            width="100%"
            placeholder="Pick date"
            style="width: 100%"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="Team">
          <el-select v-model="form.sales_assigned_ids" multiple filterable remote reserve-keyword :remote-method="searchContributedUser"
          placeholder="Please enter a keyword" :loading="loading.get_users" style="width: 100%">
            <el-option
              v-for="item in filter_contributed_users"
              :key="item.id"
              :label="item.text"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="float-right">
          <el-button v-if="form_fields_qs_answ.length > 0" size="small" type="primary" @click="nextToStep" :loading="loading.step">Next</el-button>
          <el-button v-else size="small" type="primary" @click="updateLeads" :loading="loading.update_leads">Submit</el-button>
          <el-button size="small" @click="closeModal">Cancel</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    </template>
    <el-dialog
      title="Complete Lead"
      :visible.sync="modal.action"
      width="25%">
      <el-form @reset="closeModal" class="full-width mb-5" size="lg">
        <h6 class="mb-2">Lead Name : {{ detail_card?.name }}</h6>
        <el-form-item label="Reason for losing lead">
          <el-radio-group v-model="form_action.reason" style="width: 100%">
            <el-radio v-for="item in rejected_reason" style="width: 100%"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="" v-if="form_action.reason == 'Others'">
          <el-input v-model="form_action.reason_detail" placeholder="Insert detail reasons"></el-input>
        </el-form-item>
        <el-form-item class="float-right mt-2">
          <el-button size="small" type="primary" @click="saveLost" :loading="loading.update_leads">Submit</el-button>
          <el-button size="small" @click="closeModalAction">Cancel</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { upperFirst, isEmpty, cloneDeep } from 'lodash';
import moment from 'moment';
import useVuelidate from '@vuelidate/core';
import { required, numeric } from '@vuelidate/validators';
import popupErrorMessages from '@/library/popup-error-messages';
import mime from 'mime';
import leadsAPI from '../../../api/leads';
import usersAPI from '../../../api/users';

export default {
  name: 'LeadsBoard',
  metaInfo() {
    return {
      title: 'Leads Setting',
    };
  },
  setup() {
    return {
      v$: useVuelidate(),
    };
  },
  validations() {
    return {
      form: {
        name: {
          required,
        },
        amount: {
          numeric,
        },
        contact_id: {
          required,
        },
        sales_id: {
          required,
        },
      },
    };
  },
  data() {
    return {
      loading: {
        get_leads: false,
        update_leads: false,
        create_leads: false,
        get_contacts: false,
        get_users: false,
        get_contributed_users: false,
        get_call: false,
        get_conversations: false,
        step: false,
        upload_file: false,
        leads: {},
      },
      modal: {
        add: false,
        edit: false,
        action: false,
      },
      form: {
        name: '',
        amount: '',
        due_date: '',
        contact_id: '',
        conversation_id: '',
        sales_id: '',
        source: 'Contact',
        sales_assigned_ids: [],
        call_id: '',
        fields: [],
      },
      form_fields_qs_answ: [],
      form_model: {},
      form_action: {
        reason: '',
        reason_detail: '',
      },
      loaderStack: 0,
      loader: null,
      search: {
        search: '',
        filter_type: 'lead',
      },
      total_amount: 0,
      steps_list: [],
      card_list: [],
      filter_contacts: [],
      filter_users: [],
      filter_contributed_users: [],
      detail_card: {},
      id_card: '',
      rejected_reason: [
        'Insufficient budget',
        'Product does not fit need',
        'Not satisfied with conditions',
        'Bought from competitor',
        'Others',
      ],
      filter_source: ['Contact', 'Conversation', 'Call'],
      filter_conversations: [],
      filter_calls: [],
      current_step: 0,
      selected_source: null,
      form_biodata: {
        name: '',
        age: 0,
      },
      file_max_size: {
        image: 1 * 1024 * 1024, // 5MB
        video: 16 * 1024 * 1024, // 16MB
        document: 100 * 1024 * 1024, // 100MB
      },
      dynamic_form: {
        page: 1,
        per_page: 10,
      },
    };
  },
  computed: {
    activeWorkspace() {
      return this.$store.state.workspace.activeWorkspace;
    },
    paginatedDynamicForm() {
      const start = (this.dynamic_form.page - 1) * this.dynamic_form.per_page;
      return this.form_fields_qs_answ.slice(start, start + this.dynamic_form.per_page);
    },
    totalPages() {
      return Math.ceil(this.form_fields_qs_answ.length / this.dynamic_form.per_page);
    },
  },
  mounted() {
    // const temp = [];
    /* eslint-disable no-plusplus */
    this.loadData();
    this.loadUsers();
  },
  methods: {
    initials(string) {
      return (string || '').split(' ').map((n) => n[0]).join('').slice(0, 2);
    },
    upperCaseFirst(string) {
      return upperFirst(string);
    },
    listSteps() {
      let step_arr = [];
      if (this.steps_list.length > 0) {
        step_arr = [...this.steps_list].sort((a, b) => a.order - b.order);
      }
      return step_arr;
    },
    async loadData() {
      this.showLoader();
      const response = await leadsAPI.get_steps({ workspace_id: this.activeWorkspace._id });
      this.hideLoader();
      await popupErrorMessages(response);
      this.total_amount = 0;
      if (response.data.steps) {
        this.steps_list = response.data.steps.map((v) => {
          v.data = [];
          v.count = 0;
          v.amount = 0;
          v.count_exist = 0;
          return v;
        });
        this.steps_list.forEach(async (dt) => {
          this.$set(this.loading.leads, dt.key, false);
          await this.loadListStep(dt);
        });
      } else {
        this.steps_list = [];
      }
    },
    async loadDynamicFormData(board_ids) {
      this.showLoader();
      const response = await leadsAPI.get_fields({ workspace_id: this.activeWorkspace._id }, {
        board_ids,
      });
      this.hideLoader();
      await popupErrorMessages(response);
      if (response.data) {
        this.form_fields_qs_answ = response.data.rows.reduce((acc, v) => {
          const forms = (v.additional_form || []).map((addt_form) => ({
            ...addt_form,
            status: v.status,
            deleted_at: v.deleted_at,
            field_id: v.id,
            value: addt_form.type === 'select' && addt_form.subtype === 'multiple' ? [] : '',
          }));
          return acc.concat(forms);
        }, []);
      }
    },
    async loadListStep(dt, total = null) {
      this.loading.leads[dt.key] = true;
      const idx = this.steps_list.findIndex((x) => x.key === dt.key);
      const offset = this.steps_list[idx].count_exist;
      const res = await leadsAPI.get_leads({
        workspace_id: this.activeWorkspace._id,
        step_key: dt.key,
        offset,
        search: this.search.search,
        filter_type: this.search.filter_type,
      });
      this.loading.leads[dt.key] = false;
      await popupErrorMessages(res);
      if (res.data.rows.length > 0) {
        const leads_data = res.data.rows.map((v) => {
          v.contact_name = v.contact?.display_name || v.contact?.name;
          v.participant = '';
          if (!isEmpty(v.user_contributed)) {
            const participant = v.user_contributed.map((x) => x.name).join(', ');
            v.participant = `, ${participant}`;
          }
          v.amount_str = v.amount ? parseInt(v.amount, 0).toLocaleString() : '0';
          v.due_date_str = v.due_date ? moment(v.due_date).format('DD MMM') : '';
          v.label_date = '';
          v.color_date = '';
          if (v.due_date) {
            if (moment(v.due_date).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')) {
              v.label_date = 'Today';
              v.color_date = 'warning';
            } else if (moment().format('YYYY-MM-DD') === moment(v.due_date).subtract(1, 'days').format('YYYY-MM-DD')) {
              v.label_date = 'Tomorrow';
              v.color_date = 'warning';
            } else if (moment().format('YYYY-MM-DD') === moment(v.due_date).subtract(7, 'days').format('YYYY-MM-DD')) {
              v.label_date = '1 week left';
              v.color_date = 'primary';
            } else if (moment(v.due_date).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')) {
              v.label_date = 'Overdue';
              v.color_date = 'danger';
            } else if (moment().format('YYYY-MM-DD') > moment(v.due_date).subtract(7, 'days').format('YYYY-MM-DD')) {
              const diffDays = moment(moment(v.due_date).format('YYYY-MM-DD')).endOf('day').fromNow();
              v.label_date = `${diffDays.replace('in ', '')} left`;
              v.color_date = 'primary';
            }
          }
          return v;
        });
        this.steps_list[idx].data.push(...leads_data);
        this.steps_list[idx].count = res.data.count;
        this.steps_list[idx].amount = res.data.total_amount || 0;
        this.steps_list[idx].count_exist += leads_data.length;
        if (total == null) {
          this.total_amount += parseInt(this.steps_list[idx].amount, 0);
        }
      }
      this.loading.leads[dt.key] = false;
    },
    showLoader() {
      if (this.loaderStack === 0) {
        this.loader = this.$loading.show();
      }
      this.loaderStack += 1;
    },
    hideLoader() {
      this.loaderStack -= 1;
      if (this.loaderStack === 0) {
        this.loader.hide();
      }
    },
    closeModal() {
      this.form = {
        name: '',
        amount: '',
        due_date: '',
        contact_id: '',
        conversation_id: '',
        call_id: '',
        source: 'Contact',
        fields: [],
      };

      this.current_step = 0;
      this.modal.add = false;
      this.modal.edit = false;
      this.form_fields_qs_answ = [];
    },
    async addCard() {
      this.loadDynamicFormData();
      this.modal.add = true;
    },
    async editCard(dt) {
      dt.additional_form = dt.additional_form || [];
      const board_ids = dt.additional_form.map((v) => v.field_id).join(',');
      await this.loadDynamicFormData(board_ids);
      if (dt.source_channel === 'Conversation') {
        await this.searchConversations(dt.contact.phone_number);
      } else if (dt.source_channel === 'Call') {
        await this.searchCall(dt.contact.phone_number);
      } else {
        await this.searchContact(dt.contact.phone_number);
      }
      dt.user.text = `${dt.user.name} (${dt.user.email})`;
      this.filter_users = [dt.user];
      this.filter_contributed_users = [];
      if (dt.user_contributed.length > 0) {
        this.filter_contributed_users = dt.user_contributed.map((v) => {
          v.text = `${v.name} (${v.email})`;
          return v;
        });
      }
      this.id_card = dt.id;
      this.form = {
        name: dt.name,
        amount: dt.amount,
        due_date: dt.due_date,
        contact_id: dt.contact_id,
        sales_id: dt.sales_id,
        sales_assigned_ids: dt.sales_assigned_ids,
        source: dt.source_channel || 'Contact',
        fields: dt.additional_form,
      };
      this.form_fields_qs_answ = this.form_fields_qs_answ.map((question) => {
        const answer = dt.additional_form.find((a) => a.field_id === question.field_id);
        if (!answer) return question;
        const clonedAnswer = { ...answer };
        if (question.type === 'select') {
          if (Array.isArray(clonedAnswer.value) && clonedAnswer.value.length > 0) {
            const answer_value = clonedAnswer.value.map((x) => x.label);
            clonedAnswer.value = question.subtype === 'multiple'
              ? answer_value
              : answer_value[0];
          } else {
            clonedAnswer.value = '';
          }
        } else if (question.type === 'upload') {
          if ((!clonedAnswer.value || clonedAnswer === '')) {
            clonedAnswer.value = '';
          }
        }
        return { ...question, ...clonedAnswer };
      });
      this.modal.edit = true;
    },
    detailCard(dt) {
      this.$router.push(`/leads/card/${dt.id}`);
    },
    completeLeads(command, dt) {
      if (['won', 'close'].includes(command)) {
        this.setWonClose(dt, command);
      } else if (command === 'lost') {
        this.setLost(dt);
      }
    },
    setWonClose(dt, command) {
      this.$confirm(`Are you sure want to complete ${dt.name} lead to ${command}?`, 'Complete Lead', {
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no'),
        type: 'warning',
        center: true,
        /* eslint-disable no-param-reassign */
        beforeClose: async (action, instance, cb) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            leadsAPI.complete_leads({
              workspace_id: this.activeWorkspace._id,
              id: dt.id,
              data: {
                status: command,
              },
            }).then(async (res) => {
              this.hideLoader();
              await popupErrorMessages(res);
              this.closeModal();
              this.$message({
                message: this.$t('leads.success.step.update'),
                type: 'success',
              });
              this.detail_card = {};
              this.$router.push('/leads/completed');
            }).catch(async () => {
              this.hideLoader();
            });
          }
          instance.confirmButtonLoading = false;
          cb();
        },
      }).catch(() => {});
    },
    setLost(dt) {
      this.detail_card = dt;
      this.modal.action = true;
    },
    saveLost() {
      this.loading.update_leads = true;
      leadsAPI.complete_leads({
        workspace_id: this.activeWorkspace._id,
        id: this.detail_card.id,
        data: {
          reason: this.form_action,
          status: 'lost',
        },
      }).then(async (res) => {
        this.hideLoader();
        this.loading.update_leads = false;
        await popupErrorMessages(res);
        this.closeModalAction();
        this.$message({
          message: this.$t('leads.success.step.update'),
          type: 'success',
        });
        this.detail_card = {};
        this.$router.push('/leads/completed');
      }).catch(async () => {
        this.loading.update_leads = false;
        this.hideLoader();
      });
    },
    closeModalAction() {
      this.detail_card = {};
      this.form_action = {
        reason: '',
        detail_reason: '',
      };
      this.modal.action = false;
    },
    startDrag(evt, step, card_idx) {
      evt.dataTransfer.dropEffect = 'move';
      evt.dataTransfer.effectAllowed = 'move';
      evt.dataTransfer.setData('step_from', step);
      evt.dataTransfer.setData('index_card', card_idx);
    },
    onDrop(evt, step_to) {
      console.log('evtt', evt);
      console.log('step_to', step_to);
      const step_from = evt.dataTransfer.getData('step_from');
      console.log('step_from==', step_from);
      if (step_to !== step_from) {
        this.loading.leads[step_to] = true;
        const index_card = parseInt(evt.dataTransfer.getData('index_card'), 0);
        const step_data_from = this.steps_list.find((v) => v.key === step_from);
        const step_data_to = this.steps_list.find((v) => v.key === step_to);
        const step_idx_from = parseInt(this.steps_list.findIndex((v) => v.key === step_from), 0);
        const step_idx_to = parseInt(this.steps_list.findIndex((v) => v.key === step_to), 0);
        const data_card = this.steps_list[step_idx_from].data[index_card];
        leadsAPI.update_step_leads({
          workspace_id: this.activeWorkspace._id,
          id: data_card.id,
          data: {
            step_from,
            step_to,
          },
        }).then(async (res) => {
          await popupErrorMessages(res);
          this.steps_list[step_idx_to].data = [];
          this.steps_list[step_idx_to].count = 0;
          this.steps_list[step_idx_to].count_exist = 0;
          this.steps_list[step_idx_from].data = [];
          this.steps_list[step_idx_from].count = 0;
          this.steps_list[step_idx_from].count_exist = 0;
          await this.loadListStep(step_data_from, 0);
          await this.loadListStep(step_data_to, 0);
          this.$message({
            message: this.$t('leads.success.step.update'),
            type: 'success',
          });
        }).catch(() => {});
        this.loading.leads[step_to] = false;
      }
    },
    async createLeads() {
      this.loading.update_leads = true;
      this.showLoader();
      const formfields = cloneDeep(this.form_fields_qs_answ);
      this.form.fields = await Promise.all(
        formfields.map(async (v) => {
          if (v.type === 'select') {
            v.value = v.list.filter((x) => v.value.includes(x.label));
          }
          if (v.type === 'upload' && v.value instanceof File) {
            const fileExt = mime.getExtension(v.value.type);
            const base64File = await this.toBase64(v.value);
            let messageType = '';
            if (['png', 'jpeg', 'jpg'].includes(fileExt)) {
              messageType = 'image';
            } else if (fileExt === 'mp4') {
              messageType = 'video';
            } else if (['doc', 'docx', 'xlsx', 'xls', 'pdf'].includes(fileExt)) {
              messageType = 'document';
            }
            v.messageType = messageType;
            v.originalName = v.value.name;
            v.value = base64File;
          }
          delete v.type;
          delete v.required;
          delete v.subtype;
          delete v.list;
          delete v.status;
          delete v.deleted_at;
          return v;
        }),
      );
      leadsAPI.create_leads({
        workspace_id: this.activeWorkspace._id,
        data: this.form,
      }).then(async (res) => {
        this.hideLoader();
        this.loading.update_leads = false;
        await popupErrorMessages(res);
        this.closeModal();
        this.$message({
          message: this.$t('leads.success.lead.add'),
          type: 'success',
        });
        this.loadData();
        this.current_step = 0;
      }).catch(async () => {
        this.hideLoader();
        this.loading.update_leads = false;
      });
    },
    async updateLeads() {
      this.loading.update_leads = true;
      this.showLoader();
      const formfields = cloneDeep(this.form_fields_qs_answ);
      this.form.fields = await Promise.all(
        formfields.map(async (v) => {
          if (v.type === 'select') {
            v.value = v.list.filter((x) => x && v.value.includes(x.label));
          }
          if (v.type === 'upload' && v.value instanceof File) {
            const fileExt = mime.getExtension(v.value.type);
            const base64File = await this.toBase64(v.value);
            let messageType = '';
            if (['png', 'jpeg', 'jpg'].includes(fileExt)) {
              messageType = 'image';
            } else if (fileExt === 'mp4') {
              messageType = 'video';
            } else if (['doc', 'docx', 'xlsx', 'xls', 'pdf'].includes(fileExt)) {
              messageType = 'document';
            }
            v.messageType = messageType;
            v.originalName = v.value.name;
            v.value = base64File;
          }
          delete v.type;
          delete v.required;
          delete v.subtype;
          delete v.list;
          delete v.status;
          delete v.deleted_at;
          return v;
        }),
      );
      leadsAPI.update_leads({
        workspace_id: this.activeWorkspace._id,
        id: this.id_card,
        data: this.form,
      }).then(async (res) => {
        this.hideLoader();
        this.loading.update_leads = false;
        await popupErrorMessages(res);
        this.closeModal();
        this.$message({
          message: this.$t('leads.success.lead.update'),
          type: 'success',
        });
        this.current_step = 0;
        this.loadData();
      }).catch(async () => {
        this.hideLoader();
        this.loading.update_leads = false;
      });
    },
    deleteLeads(dt) {
      this.$confirm(`Are you sure want to delete ${dt.name} lead?`, 'Delete Lead', {
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no'),
        type: 'warning',
        center: true,
        /* eslint-disable no-param-reassign */
        beforeClose: async (action, instance, cb) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            leadsAPI.delete_leads({
              workspace_id: this.activeWorkspace._id,
              id: dt.id,
            }).then(async (res) => {
              this.hideLoader();
              await popupErrorMessages(res);
              this.closeModal();
              this.$message({
                message: this.$t('leads.success.lead.delete'),
                type: 'success',
              });
              this.loadData();
            }).catch(async () => {
              this.hideLoader();
            });
          }
          instance.confirmButtonLoading = false;
          cb();
        },
      }).catch(() => {});
    },
    async searchContact(keyword) {
      this.filter_contacts = [];
      if (keyword?.length > 2) {
        this.loading.get_contacts = true;
        await leadsAPI.searchContacts({
          workspace_id: this.activeWorkspace._id,
          keyword,
        }).then((res) => {
          this.filter_contacts = res.data.map((v) => {
            const x = {
              id: v.id,
              label: `${this.isChatPrivacy(v.display_name || v.name)} (${this.isChatPrivacy(v.phone_number)})`,
            };
            return x;
          });
        }).catch((err) => {
          console.log(err);
        });
        this.loading.get_contacts = false;
      }
    },
    async searchCall(keyword) {
      this.filter_calls = [];
      if (keyword?.length > 2) {
        this.loading.get_call = true;
        await leadsAPI.searchCall({
          workspace_id: this.activeWorkspace._id,
          keyword,
        }).then((res) => {
          this.filter_calls = res.data.map((v) => {
            const x = {
              call_id: v.id,
              contact_id: v.contact.id,
              calling_at: v.calling_at ? moment(v.calling_at).format('YYYY-MM-DD HH:mm:ss') : moment(v.created_at).format('YYYY-MM-DD HH:mm:ss'),
              label: `${this.isChatPrivacy(v.contact.name)}, ${this.isChatPrivacy(v.contact.phone_number)}, ${v.calling_at ? moment(v.calling_at).format('YYYY-MM-DD HH:mm:ss') : moment(v.created_at).format('YYYY-MM-DD HH:mm:ss')}`,
            };
            return x;
          });
        }).catch((err) => {
          console.log(err);
        });
        this.loading.get_call = false;
      }
    },
    async searchConversations(keyword) {
      this.filter_conversations = [];
      if (keyword?.length > 2) {
        this.loading.get_conversations = true;
        await leadsAPI.searchConversations({
          workspace_id: this.activeWorkspace._id,
          keyword,
        }).then((res) => {
          this.filter_conversations = res.data.map((v) => {
            const x = {
              conversation_id: v.id,
              contact_id: v.contacts[0].id,
              label: `${this.isChatPrivacy(v.contacts[0].name)}, ${this.isChatPrivacy(v.contacts[0].phone_number)}, #${v.code}`,
            };
            return x;
          });
        }).catch((err) => {
          console.log(err);
        });
        this.loading.get_conversations = false;
      }
    },
    loadUsers() {
      this.searchUser();
    },
    async searchUser(keyword = '') {
      this.filter_users = [];
      this.loading.get_users = true;
      await usersAPI.getList(1, keyword).then((res) => {
        this.filter_users = res.data.rows.map((v) => {
          const x = {
            id: v.id,
            text: `${v.name} (${v.email})`,
          };
          return x;
        });
      }).catch((err) => {
        console.log(err);
      });
      this.loading.get_users = false;
    },
    async searchContributedUser(keyword = '') {
      this.filter_contributed_users = [];
      this.loading.get_contributed_users = true;
      await usersAPI.getList(1, keyword).then((res) => {
        this.filter_contributed_users = res.data.rows.map((v) => {
          const x = {
            id: v.id,
            text: `${v.name} (${v.email})`,
          };
          return x;
        });
      }).catch((err) => {
        console.log(err);
      });
      this.loading.get_contributed_users = false;
    },
    async onChangeSourceTypeId(item) {
      if (this.form.source === 'Conversation') {
        const selected_conversation = this.filter_conversations.find((v) => v.conversation_id === item);
        this.form.conversation_id = item;
        this.form.contact_id = selected_conversation.contact_id;
      } else if (this.form.source === 'Call') {
        const selected_call = this.filter_calls.find((v) => v.call_id === item);
        this.form.call_id = item;
        this.form.contact_id = selected_call.contact_id;
      }
    },
    nextToStep() {
      if (this.current_step === 0) {
        if (!this.form.contact_id || !this.form.name || !this.form.sales_id) {
          this.$message({
            message: this.$t('leads.failed.lead.next_leads_step'),
            type: 'error',
          });
          return;
        }
        this.current_step += 1;
      } else if (this.current_step === 1) {
        if (this.dynamic_form.page < this.totalPages) {
          this.dynamic_form.page += 1;
        } else {
          this.current_step += 1;
        }
      } else {
        this.current_step += 1;
      }
    },
    backToStep() {
      if (this.current_step === 1 && this.dynamic_form.page > 1) {
        this.dynamic_form.page -= 1;
      } else {
        this.current_step -= 1;
      }
    },
    validateRequiredField(field) {
      return (rule, value, callback) => {
        if (field.required && (!field.value || field.value === '')) {
          return callback(new Error(`This field ${field.label} is required`));
        }
        if (field.type === 'upload' && field.value && !field.value.secure_url) {
          const { type, size } = field.value;
          const fileExt = mime.getExtension(type);
          if (['png', 'jpeg', 'jpg'].includes(fileExt) && (size > this.file_max_size.image)) {
            return callback(new Error('Maximum image 5MB'));
          }
          if (fileExt === 'mp4' && (size > this.file_max_size.video)) {
            return callback(new Error('Maximum video 16MB'));
          }
          if (
            ['doc', 'docx', 'xlsx', 'xls', 'pdf'].includes(fileExt)
            && (size > this.file_max_size.document)
          ) {
            return callback(new Error('Maximum document 100MB'));
          }
        }
        return callback();
      };
    },
    validateLeadField(cb) {
      const formRef = this.$refs.dynamicFormValidation;
      if (formRef && typeof formRef.validate === 'function') {
        formRef.validate((valid) => {
          if (!valid) return false;
          cb();
          return true;
        });
      } else {
        cb();
      }
    },
    validateCreateLeadField() {
      this.validateLeadField(this.createLeads);
    },
    validateUpdateLeadField() {
      this.validateLeadField(this.updateLeads);
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    isChatPrivacy(number) {
      let phone_number = number?.trim();
      if (phone_number && this.$store.state.auth.userProfile.is_pic !== true && this.$store.state.auth.userProfile.agents && this.$store.state.auth.userProfile.agents[0] && this.activeWorkspace.configuration && this.activeWorkspace.configuration.chat_privasi && this.activeWorkspace.configuration.chat_privasi.masking_phone_number === true) {
        if (phone_number.charAt(0) === '0') {
          phone_number = phone_number.replace('0', '62');
        }
        if (this.validatePhoneNumber(phone_number)) {
          return `${phone_number.substring(0, 2)}********${phone_number.substring(phone_number.length - 2)}`;
        }
      }
      return phone_number;
    },
    validatePhoneNumber(phone_number) {
      const validateRegex = /^\+?[1-9][0-9]{7,14}$/;
      return validateRegex.test(`+${phone_number}`);
    },
  },
};
</script>

<style lang="scss">
  .feather-16 {
    width: 14px;
    height: 14px;
  }
  [data-initials-contact]:before {
    background: #8CC8ED;
    outline-color: #00000000;
    color: white;
    opacity: 1;
    content: attr(data-initials-contact);
    display: inline-block;
    font-weight: bold;
    border-radius: 50%;
    vertical-align: middle;
    margin-right: 0.2em;
    width: 30px;
    height: 30px;
    line-height: 30px;
    text-align: center;
  }
</style>
